import { FC } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { DatePicker } from "../../../common/components/DatePicker/DatePicker";
import { List } from "../../../common/components/List/List";
import { OrderList } from "../../../common/components/Order/OrderList";
import {
  setActiveOrderId,
  setOrdersDateFrom,
  setOrdersDateTo,
} from "./desktopSlice";
import { ORDER_STATUS } from "common/utils/consts";
import { IOrder } from "common/models/order/IOrder";

// На рабочем столе показываем заказы, которые сейчас ищутся или в работе.
// Заказы «В обработке» (помощь в подборе техники) и «На проверке» разбираются
// в своих разделах, отменённые и завершённые уже не требуют действий менеджера
const HIDDEN_ORDER_STATUSES: number[] = [
  ORDER_STATUS.PROCESSING,
  ORDER_STATUS.ON_REVIEW,
  ORDER_STATUS.REJECTED,
  ORDER_STATUS.FINISHED,
];

export const DESKTOP_ORDER_STATUSES = Object.values(ORDER_STATUS).filter(
  (statusId) => !HIDDEN_ORDER_STATUSES.includes(statusId)
);

export const OrdersTabs: FC = () => {
  const activeOrderId = useAppSelector(
    (state) => state.platformManager.desktop.activeOrderId
  );
  const ordersDateFrom = useAppSelector(
    (state) => state.platformManager.desktop.ordersDateFrom
  );
  const ordersDateTo = useAppSelector(
    (state) => state.platformManager.desktop.ordersDateTo
  );

  const dispatch = useAppDispatch();

  const handleSetActiveOrder = (order: IOrder) => {
    dispatch(setActiveOrderId(order.id));
  };

  const handleOrdersDateFromChange = (date: Nullable<Date>) => {
    dispatch(setOrdersDateFrom(date?.toLocaleDateString("sv") || undefined));
  };

  const handleOrdersDateToChange = (date: Nullable<Date>) => {
    dispatch(setOrdersDateTo(date?.toLocaleDateString("sv") || undefined));
  };

  return (
    <>
      <div>
        <DatePicker
          onStartDateChange={handleOrdersDateFromChange}
          onEndDateChange={handleOrdersDateToChange}
          placeholderText="Введите промежуток дат"
          isClearable={true}
        />
      </div>

      <List className="mt-[10px] overflow-y-scroll">
        <OrderList
          filter={{
            statusId: DESKTOP_ORDER_STATUSES,
            dateFrom: ordersDateFrom,
            dateTo: ordersDateTo,
          }}
          activeOrderId={activeOrderId}
          onItemClick={handleSetActiveOrder}
          withAddresses
        />
      </List>
    </>
  );
};
